import React from 'react';
import styles from '../search.scss';

const AdultTeamClubsHeaderColumns = props => {
    const {
        filterType,
        adultTeamClubs,
        // functions
        sortResults,
    } = props;

    let sortValue = '';
    if (adultTeamClubs.sort && adultTeamClubs.sort.field) {
        sortValue = `${adultTeamClubs.sort.field}_${adultTeamClubs.sort.asc ? 'asc' : 'desc'}`;
    }
    const sortOptions = [
        { value: 'name_asc', label: 'Name: A to Z' },
        { value: 'name_desc', label: 'Name: Z to A' },
    ];

    const sort = (val) => {
        const sortBy = val.split('_');
        sortResults('adultTeamClubs', sortBy[0], sortBy[1]);
    };

    const getFilterColumnHeaderText = (columnFiled, columnHeader, nonFilterTypeText) => {
        if (!filterType && nonFilterTypeText) {
            return (<span data-testid="search.adult-team-clubs.column-header.name-label">{nonFilterTypeText}</span>);
        }

        return (
            <span data-testid="search.adult-team-clubs.column-header.name-label">
                {columnHeader}
                &nbsp;
                <i className={`uts ${adultTeamClubs.sort.field === columnFiled && !adultTeamClubs.sort.asc ? 'uts-expand' : 'uts-collapse'}`} />
            </span>
        );
    };

    if (adultTeamClubs.total <= 0) {
        return <></>;
    }

    return (
        <div>
            <div className={`${styles.searchHeaders} d-none d-md-flex`} data-testid="search.adult-team-clubs.column-headers">
                <div className="flex-grow">
                    <div className="row">
                        <div
                            className={`col-md-8 ${styles.searchHeaderColumn} ${filterType && styles.clickable} ${filterType && adultTeamClubs.sort.field === 'name' ? 'active' : ''}`}
                            onClick={() => { return filterType ? sortResults('adultTeamClubs', 'name') : null; }}
                            data-testid="search.adult-team-clubs.column-header.name"
                        >
                            {getFilterColumnHeaderText('name', 'Name', 'Adult Team Clubs')}
                        </div>
                        <div className={`col-md-4 ${styles.searchHeaderColumn}`} data-testid="search.adult-team-clubs.column-header.location">Location</div>
                    </div>
                </div>
            </div>
            <div className={`${styles.searchHeaders} d-block d-md-none`} data-testid="search.adult-team-clubs.column-headers-mobile">
                {filterType ? (
                    <div data-testid="search.adult-team-clubs.sort-by-wrapper">
                        Sort by
                        <select
                            className="inline-input"
                            value={sortValue}
                            onChange={(e) => sort(e.target.value)}
                            data-testid="search.adult-team-clubs.sort-select"
                        >
                            <option value="">Relevance</option>
                            {sortOptions.map((option, i) => <option value={option.value} key={`adultTeamClubSort${i}`}>{option.label}</option>)}
                        </select>
                    </div>
                ) : 'Adult Team Clubs'}
            </div>
        </div>
    );
};

export default AdultTeamClubsHeaderColumns;
